import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const MembershipBasicInfoComponent = ({ onInnerBasicFormChange, selectedMember, shippingProviders }: any) => {

    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer

                        label="Enable"
                        name="IsEnabled"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedMember?.IsEnabled}
                    />

                    <InputContainer

                        label="Active"
                        name="IsActive"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsActive'
                            )
                        }}
                        type="checkbox"
                        value={selectedMember?.IsActive}
                    />

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedMember?.Name}
                    />

                    <InputContainer
                        label="Start Date"
                        name="StartDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'StartDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedMember?.StartDateUtc}
                    />

                    <InputContainer
                        label="End Date"
                        name="EndDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EndDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedMember?.EndDateUtc}
                    />

                    <div className='col-span-full'>
                        <InputContainer
                            label="Description"
                            name="Description"
                            onValueChange={(event: any) => {
                                onInnerBasicFormChange(
                                    event.target.value,
                                    'Description'

                                )
                            }}
                            type="text"
                            value={selectedMember?.Description}
                        />
                    </div>

                </div>
            }
            expandedPanel="Basic Info"
            headerTitle="Basic Info"
        />
        </>

    )
}
export default MembershipBasicInfoComponent;
